import apiInstance from '../services/ServiceApi';

const lineaNegocioApi = {

    getLineaNegocio: async () => {
        try {
            const response = await apiInstance.get('/lineasnegocio/');
            return response.data;
            } catch (error) {
            console.error("Error al obtener los usuarios:", error);
            throw error;
        }
    },
    getDashboards: async (linea_negocio_id) => {
        try {
            const response = await apiInstance.get(`/dashboard/linea_negocio/${linea_negocio_id}/`);
            return response.data;
            } catch (error) {
            console.error("Error al obtener los usuarios:", error);
            throw error;
        }
    },
    getDashboardUser: async () => {
        try {
            const response = await apiInstance.get(`/dashboard/user/`);
            return response.data;
            } catch (error) {
            console.error("Error al obtener los usuarios:", error);
            throw error;
        }
    },
    createDashboard: async (payload) => {
        try {
            const response = await apiInstance.post(`/dashboard/`, payload);
            return response.data;
            } catch (error) {
            console.error("Error al obtener los usuarios:", error);
            throw error;
        }
    },
    updateDashboard: async (linea_negocio_id,payload) => {
        try {
            const response = await apiInstance.patch(`/dashboard/${linea_negocio_id}/`, payload);
            return response.data;
            } catch (error) {
            console.error("Error al obtener los usuarios:", error);
            throw error;
        }
    },
    deteleDashboards: async (dashboard) => {
        try {
            const response = await apiInstance.delete(`/dashboard/${dashboard}/`);
            return response.data;
            } catch (error) {
            console.error("Error al obtener los usuarios:", error);
            throw error;
        }
    },

};

export default lineaNegocioApi;
